import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Accordion,
  AccordionDetails,
  Box,
  Grid,
  CircularProgress,
  Backdrop,
  Typography,
  Alert,
} from "@mui/material";
import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { styled } from "@mui/material/styles";
import { object, SchemaOf, string } from "yup";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { AddData } from "src/app-redux/common-actions";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ICompanyProfileItem } from "src/common/typings/companyProfile";
import { formatCompanyProfileData } from "src/common/utils/companyProfile";
import AsynCommonAutoCompleteField from "src/components/CommonAutoCompleteField/AsynCommonAutoCompleteField";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonTextField from "src/components/CommonTextField/CommonTextField";
import NoRecordFound from "src/components/NoRecordFound";
import { Card } from "./Card";
import Heading from "./Heading";
import { useStyles } from "./styles";

const StyledPhoneInputContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  "& .react-tel-input": {
    "& .flag-dropdown": {
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRight: "none",
      borderRadius: "4px 0 0 4px",
      background: "transparent",
      "&.open": {
        borderColor: theme.palette.primary.main,
        borderRight: "none",
      },
    },
    "& .selected-flag": {
      height: "40px",
      "&:hover": {
        background: "transparent",
      },
      "&:focus": {
        background: "transparent",
      },
    },
    "& input": {
      width: "100%",
      height: "40px",
      fontSize: "14px",
      paddingLeft: "48px",
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRadius: "4px",
      "&:focus": {
        borderColor: theme.palette.primary.main,
        borderWidth: "2px",
      },
      "&:hover": {
        borderColor: "rgba(0, 0, 0, 0.87)",
      },
    },
  },
}));

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};
const validationSchema: SchemaOf<{ contactEmail: string }> = object().shape({
  contactEmail: string()
    .max(255)
    .default("")
    .defined("")
    .nullable()
    .test(
      "superior",
      'Email format invalid should be like "example1@domain.com;example2@domain.com" ',
      function (f) {
        const refemail: string | null = f;
        const emailFormateList: any = refemail?.split(";");
        if (refemail && emailFormateList.length) {
          let valemail = true;
          emailFormateList.map((em: string) => {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(em)) {
              valemail = false;
              return;
            } else {
              valemail = true;
            }
          });
          return valemail;
        } else {
          return true;
        }
      }
    ),
});
export function ProfileInfo({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const [profileInfo, setProfileInfo] = useState<ICompanyProfileItem | any>({});
  const [editcp, setEditcp] = useState(false);
  const [fristTimeExpend, setFristTimeExpend] = useState(false);
  const [achMessage, setAchMessage] = useState<string>("");
  const [states, setStates] = useState<any>();
  const [cities, setCities] = useState<any>();
  const [states1, setStates1] = useState<any>();
  const [cities1, setCities1] = useState<any>();
  const formik = useFormik<ICompanyProfileItem>({
    enableReinitialize: false,
    initialValues: {
      address: "",
      city: "",
      zip: "",
      state: "",
      company: "",
      contactEmail: "",
      contactPerson: "",
      fax: "",
      checkAddress: "",
      checkCity: "",
      checkState: "",
      checkZip: "",
      checkCompany: "",
      phone: "",
      remitType: "",
      serviceFee: 0,
      isServiceFee: false,
      checkDBA: "",
      allowGuestIVR: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const clone = JSON.parse(JSON.stringify(values));
      // react-phone-input-2 returns phone in international format (e.g., "12025551234")
      // Remove any non-digit characters if present
      if (clone.phone) clone.phone = clone.phone.replace(/\D/g, "");
      setLoader(true);
      const body = formatCompanyProfileData(clone);
      try {
        await dispatch(
          AddData(
            "/update-vendor-detail-by-vend-num",
            "Company profile successfully",
            JSON.stringify(body)
          )
        );
        setEditcp(false);
        getOrderInfoData();
      } catch (error) {
        setLoader(false);
      }
      setLoader(false);
    },
  });
  const getOrderInfoData = async () => {
    try {
      setLoader(true);
      const results = (await fetchWrapper.get(
        "get-vendor-detail-by-vend-num"
      )) as ICompanyProfileItem;
      setProfileInfo(results);
      return setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  const resetStatesAndCities = async () => {
    setLoader(true);
    const { states } = await fetchWrapper.get("/get-states");
    const { cities } = await fetchWrapper.get("/get-cities");
    const res: any[] = [];
    if (states?.length > 0) {
      states.map((v: any) => {
        const obj: any = {
          label: v,
          value: v,
        };
        res.push(obj);
      });
    }
    setStates(res);
    setStates1(res);
    setCities(cities || []);
    setCities1(cities || []);
    setLoader(false);
    setFristTimeExpend(true);
  };
  const getValueWRTzip = async (zip: string) => {
    setLoader(true);
    const { data } = await fetchWrapper.get(`/get-cities-states-counties-by-zip/${zip || ""}`);
    const { states, cities } = data;
    const res: any[] = [];
    if (states?.length > 0) {
      states.map((v: any) => {
        const obj: any = {
          label: v,
          value: v,
        };
        res.push(obj);
      });
    }
    setStates(res);
    setCities(cities ? cities : []);
    setLoader(false);
  };
  const getValueWRTzip1 = async (zip: string) => {
    setLoader(true);
    const { data } = await fetchWrapper.get(`/get-cities-states-counties-by-zip/${zip || ""}`);
    const { states, cities } = data;
    const res: any[] = [];
    if (states?.length > 0) {
      states.map((v: any) => {
        const obj: any = {
          label: v,
          value: v,
        };
        res.push(obj);
      });
    }
    setStates1(res);
    setCities1(cities || []);
    setLoader(false);
  };
  const getCitiesWRTstate = async (st: string) => {
    setLoader(true);
    const { cities } = await fetchWrapper.get(`/get-cities/${st || ""}`);
    setCities(cities || []);
    setLoader(false);
  };
  const getCitiesWRTstate1 = async (st: string) => {
    setLoader(true);
    const { cities } = await fetchWrapper.get(`/get-cities/${st || ""}`);
    setCities1(cities || []);
    setLoader(false);
  };
  const getVendorAchMessage = async () => {
    setLoader(true);
    const { vendorAchMessage } = await fetchWrapper.get("get-vendor-portal-ach-message");
    setAchMessage(vendorAchMessage);
    setLoader(false);
  };
  const { setValues, values, submitForm } = formik;
  const {
    address,
    city,
    zip,
    state,
    contactPerson,
    fax,
    checkAddress,
    checkCity,
    checkState,
    checkZip,
    checkCompany,
    phone,
    contactEmail,
    remitType,
    checkDBA,
  } = values;
  useEffect(() => {
    if (expand) {
      getOrderInfoData();
      if (!achMessage) {
        getVendorAchMessage();
      }
      if (!fristTimeExpend) {
        resetStatesAndCities();
      }
    }
  }, [expand]);
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={() => updateExpandStatus(0)}>
          <Heading heading="Profile" />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Grid container direction="row" data-testid="grid-container">
              <Grid item xs={12} md={12} data-testid="grid-item">
                {Boolean(Object.keys(profileInfo).length) ? (
                  <Card
                    InfoData={profileInfo || {}}
                    editCompany={() => {
                      const clone = JSON.parse(JSON.stringify(profileInfo));
                      formik.setValues(clone);
                      setEditcp(true);
                    }}
                  />
                ) : (
                  <NoRecordFound />
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
      <Grid container direction="row" spacing={2}>
        <CommonDrawer
          heading={"Profile"}
          isOpen={editcp}
          closeDrawer={() => {
            setEditcp(false);
          }}
          drawerWidth={550}
        >
          <Box mt={2} />
          <Grid container spacing={2} direction="row">
            <Grid item xs={12}>
              <Box color="text.primary">
                <Typography component="label" variant="body1">
                  Company
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <CommonTextField
                // required
                label="Address"
                onChange={(v: any) => {
                  setValues({ ...values, address: v.target.value });
                }}
                name="address"
                value={address}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <AsynCommonAutoCompleteField
                label="City"
                name="city"
                optionsType={cities?.length ? cities : []}
                getOptionLabel={(option: any) => option || ""}
                value={cities && cities?.length ? cities.find((cit: any) => cit === city) : null}
                handleChange={(v) => {
                  setValues({ ...values, city: v });
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <CommonAutoCompleteField
                label="State"
                name="state"
                optionsType={states || []}
                getOptionLabel={(option: any) => option.label || ""}
                value={states?.find(({ value }: any) => value === state) || null}
                onChange={(option: any) => {
                  if (!option?.value) {
                    setValues({
                      ...values,
                      state: "",
                      zip: "",
                      city: "",
                    });
                    resetStatesAndCities();
                  } else {
                    setValues({ ...values, state: option?.value || "" });
                    if (!values.zip) getCitiesWRTstate(option?.value);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextField
                // required
                label="Zip"
                onChange={(v: any) => {
                  setValues({ ...values, zip: v.target.value });
                }}
                onBlur={(e: any) => {
                  if (e.currentTarget.value) {
                    setValues({
                      ...values,
                      zip: e.currentTarget.value,
                    });
                    getValueWRTzip(e.currentTarget.value);
                  } else {
                    resetStatesAndCities();
                  }
                }}
                name="zip"
                value={zip}
              />
            </Grid>
            <Grid item xs={12}>
              <Box color="text.primary">
                <Typography component="label" variant="body1">
                  Contact
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonTextField
                // required
                label="Contact Person"
                onChange={(v: any) => {
                  setValues({ ...values, contactPerson: v.target.value });
                }}
                name="contactPerson"
                value={contactPerson}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonTextField
                // required
                label="Contact Email"
                onChange={(v: any) => {
                  setValues({ ...values, contactEmail: v.target.value });
                }}
                error={formik.touched.contactEmail && Boolean(formik.errors.contactEmail)}
                helperText={formik.touched.contactEmail && formik.errors.contactEmail}
                name="contactEmail"
                value={contactEmail}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <StyledPhoneInputContainer>
                <Typography
                  component="label"
                  variant="body2"
                  sx={{
                    position: "absolute",
                    top: "-8px",
                    left: "14px",
                    background: "white",
                    padding: "0 4px",
                    fontSize: "12px",
                    color: "rgba(0, 0, 0, 0.6)",
                    pointerEvents: "none",
                    zIndex: 3,
                  }}
                >
                  Phone
                </Typography>
                <PhoneInput
                  country={"us"}
                  value={phone}
                  onChange={(value: string) => {
                    setValues({ ...values, phone: value });
                  }}
                  inputStyle={{
                    width: "100%",
                    height: "40px",
                    fontSize: "14px",
                    paddingLeft: "48px",
                  }}
                  buttonStyle={{
                    height: "40px",
                  }}
                  containerStyle={{
                    width: "100%",
                  }}
                />
              </StyledPhoneInputContainer>
            </Grid>
            <Grid item xs={12} md={6}>
              <CommonTextField
                // required
                label="Fax"
                onChange={(v: any) => {
                  setValues({ ...values, fax: v.target.value });
                }}
                type="number"
                name="fax"
                value={fax}
              />
            </Grid>
            <Grid item xs={12}>
              <Box mb={1.5} color="text.primary">
                <Typography component="label" variant="body1">
                  Check Address
                </Typography>
              </Box>
            </Grid>
            {remitType === "ACH" ? (
              <Alert className={classes.muiAlartRoot} severity="info">
                <span dangerouslySetInnerHTML={{ __html: achMessage }} />
              </Alert>
            ) : (
              <>
                <Grid item xs={12} md={6}>
                  <CommonTextField
                    label="Company"
                    onChange={(v: any) => {
                      setValues({ ...values, checkCompany: v.target.value });
                    }}
                    isReadOnly
                    name="checkCompany"
                    value={checkCompany}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CommonTextField
                    label="DBA"
                    onChange={(v: any) => {
                      setValues({ ...values, checkDBA: v.target.value });
                    }}
                    name="checkDBA"
                    value={checkDBA}
                    isReadOnly
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CommonTextField
                    label="Address"
                    onChange={(v: any) => {
                      setValues({ ...values, checkAddress: v.target.value });
                    }}
                    isReadOnly
                    name="checkAddress"
                    value={checkAddress}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <AsynCommonAutoCompleteField
                    label="City"
                    name="checkCity"
                    disabled
                    optionsType={cities1}
                    getOptionLabel={(option: any) => option || ""}
                    value={
                      cities1 && cities1?.length
                        ? cities1.find((city: any) => city === checkCity)
                        : null
                    }
                    handleChange={(v) => {
                      setValues({ ...values, checkCity: v });
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CommonAutoCompleteField
                    label="State"
                    name="checkState"
                    disabled
                    optionsType={states1}
                    getOptionLabel={(option: any) => option.label || ""}
                    value={states1?.find(({ value }: any) => value === checkState) || null}
                    onChange={(option: any) => {
                      if (!option?.value) {
                        setValues({
                          ...values,
                          checkState: "",
                          checkZip: "",
                          checkCity: "",
                        });
                        resetStatesAndCities();
                      } else {
                        setValues({ ...values, checkState: option?.value || "" });
                        if (!values.checkZip) getCitiesWRTstate1(option?.value);
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CommonTextField
                    label="Zip"
                    isReadOnly
                    onChange={(v: any) => {
                      setValues({ ...values, checkZip: v.target.value });
                    }}
                    onBlur={(e: any) => {
                      if (e.currentTarget.value) {
                        setValues({
                          ...values,
                          checkZip: e.currentTarget.value,
                        });
                        getValueWRTzip1(e.currentTarget.value);
                      } else {
                        resetStatesAndCities();
                      }
                    }}
                    name="checkZip"
                    value={checkZip}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <Box mt={2} mb={2} textAlign="right">
                <Box component="span" mr={2}>
                  <CommonButton
                    onClick={() => {
                      setEditcp(false);
                    }}
                  >
                    Cancel
                  </CommonButton>
                </Box>
                <Box component="span">
                  <CommonButton
                    isGreen
                    onClick={() => {
                      submitForm();
                    }}
                  >
                    Save
                  </CommonButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </CommonDrawer>
      </Grid>
    </>
  );
}
